
import RulerOpen from "../../../assets/filled/RulerOpen.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RulerOpenIcon({ className, dataTestid = "RulerOpenIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RulerOpen data-testid={dataTestid} className={classes} {...rest} />
  );
}
